import { render } from "./WordViewer.vue?vue&type=template&id=2196095e&scoped=true"
import script from "./WordViewer.vue?vue&type=script&lang=js"
export * from "./WordViewer.vue?vue&type=script&lang=js"

import "./WordViewer.vue?vue&type=style&index=0&id=2196095e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2196095e"]])

export default __exports__